export const USER_LOGOUT = 'USER_LOGOUT';
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT';
export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';
export const CLEAR_ORDER_HISTORY = 'CLEAR_ORDER_HISTORY';
export const SET_IMPERSONATION = 'SET_IMPERSONATION';
export const CHANGE_FETCHING = 'CHANGE_FETCHING';

export const UNAVAILABLE_ERROR = 'UNAVILABLE_ERROR';
